__webpack_require__.p = "https://sdkstatic.onemt.co/event/christmas2025/";